angular
	.module('totalePratiche.components', [])
	.component('totalePratiche', {
		templateUrl: 'ng/components/totalePratiche/totalePratiche.html',
		bindings: {
			/** Input data **/
			
			titolo:'@',
			totalePratiche : '<',
			importoTotalePratiche: '<',
			onPrint: '&?',
			onSee: '&?'

		},
		controllerAs: 'totalePraticheCtrl',
		controller: function totalePratiche() {

			var self = this;
			self.titolo="";

			self.$onInit = function () {
				self.titolo = "totale gruppo/cliente";
			}
			
		}
	});
